<div class="group-container">
  <form #groupForm="ngForm" class="group-form">
    <rms-select name="Country" [required]="true" [options]="Countries" label="Country" [(ngModel)]="Group.CountryID" labelKey="CountryName" valueKey="CountryID" (ngModelChange)="onSelectCountry()"></rms-select>
    @if(Group.CountryID){
    <fieldset class="rms-fieldset">
      <div class="available-group-container">
        @for(group of GroupList; track group.GroupID){
        <div class="group-object">{{group.GroupName}} ({{group.IsParent ? 'Parent' : 'Child'}})</div>
        }
      </div>
    </fieldset>
    <rms-input name="GroupName" [required]="true" label="Group Name" [(ngModel)]="Group.GroupName"></rms-input>
    <rms-radio name="Relation" [required]="true" [options]="[{label: 'Parent', value: 'Parent'}, {label: 'Child', value: 'Child'}]" label="Is this a parent group or child group?" [(ngModel)]="Group.Relation" [flexRow]="true"></rms-radio>
    @if(Group.Relation === 'Child'){
    <rms-select name="ParentGroup" [required]="Group.Relation === 'Child'" [options]="ParentGroups" label="Parent Group" [(ngModel)]="Group.ParentID" labelKey="GroupName" valueKey="GroupID"></rms-select>
    }
    }
  </form>
  <div class="button-container">
    <button mat-button class="btn-bg-green" [disabled]="!groupForm.valid" (click)="save()">Save</button>
    <button mat-button class="btn-bg-red" (click)="cancel()">Cancel</button>
  </div>
</div>
